import React from "react";
export var Loading = _ref => {
  var {
    size = 24
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      width: size,
      marginRight: "0.2rem"
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    className: "spinner",
    viewBox: "0 0 50 50",
    style: {
      display: "inline",
      verticalAlign: "middle"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    className: "path"
  })));
};
//# sourceMappingURL=loading.js.map